import styled from 'styled-components'
import { font } from 'lib/core/resources/helpers/styled'

export const Container = styled.div`
  .image {
    background: ${props => props.theme.palette.general.greyLight} no-repeat 50% 50% / cover;
    height: 250px;
    border-radius: 5px;
  }

  .content {
    margin: 0 auto;
    padding: 15px;
    box-sizing: border-box;
    color: ${props => props.theme.palette.primary.alphaDark};
    display: flex;
    flex-direction: column;
  }

  .title {
    font: ${font('default', 'medium', '22px/1')};
    margin-bottom: 20px;
  }

  .subtitle {
    font: ${font('default', 'normal', '18px/1.2')};
    overflow: hidden;
    text-overflow: ellipsis;
    /* stylelint-disable */
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
  }

  .tags {
    padding: 0;
    margin: 0 0 20px;
    list-style: none;
    display: flex;
    flex-wrap: wrap;

    a {
      color: ${props => props.theme.palette.primary.alphaDark};
      padding: 2px 5px;
      background: ${props => props.theme.palette.general.greyLight};
      border: 1px solid ${props => props.theme.palette.general.grey};
      border-radius: 3px;
      text-transform: uppercase;
      font: ${font('default', 'medium', '16px/1')};
      transition: opacity ease-in-out 0.3s;
      margin: 2px 5px;
      display: inline-block;

      &:hover {
        opacity: 0.8;
      }
    }
  }

  .date {
    margin: 15px 0 10px;
    font: ${font('default', 'normal', '16px/1')};
    color: ${props => props.theme.palette.general.greyDark};
  }

  .action {
    background: ${props => props.theme.palette.general.greyLight};
    border-top: 1px solid ${props => props.theme.palette.general.grey};
    border-radius: 0 0 4px 4px;
    padding: 10px 15px;
    text-align: right;
    font: ${font('default', 'bold', '16px/1')};
    color: ${props => props.theme.palette.primary.alphaDark};
  }

  a {
    user-select: none;
    text-decoration: none;
  }
`
